import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiEdit3, FiTarget, FiPlayCircle, FiMessageSquare, FiAward } = FiIcons;

const STEPS = [
  { title: 'Registration', icon: FiEdit3, desc: 'Simple enrollment process for individuals or corporate groups.' },
  { title: 'Assessment', icon: FiTarget, desc: 'Evaluating baseline knowledge to tailor the approach.' },
  { title: 'Training', icon: FiPlayCircle, desc: 'Engaging, practical, and comprehensive learning sessions.' },
  { title: 'Evaluation', icon: FiMessageSquare, desc: 'Rigorous testing to ensure complete understanding.' },
  { title: 'Certification', icon: FiAward, desc: 'Official accreditation upon successful completion.' },
];

const Journey = () => {
  return (
    <section id="journey" className="py-24 bg-white relative">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-alpha-green font-semibold tracking-wider uppercase mb-2 text-sm">Training Journey</h2>
          <h3 className="text-3xl md:text-4xl font-bold text-alpha-navy">The Path to Competency</h3>
        </div>

        <div className="relative">
          {/* Desktop Curved Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 w-full h-1 bg-gray-200 -translate-y-1/2 overflow-hidden rounded-full">
             <motion.div 
               className="h-full bg-alpha-green"
               initial={{ width: "0%" }}
               whileInView={{ width: "100%" }}
               viewport={{ once: true }}
               transition={{ duration: 1.5, ease: "easeInOut" }}
             />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 relative z-10">
            {STEPS.map((step, index) => (
              <motion.div 
                key={step.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                className="flex flex-col items-center text-center group"
              >
                {/* Mobile vertical line connector */}
                {index !== 0 && <div className="lg:hidden w-0.5 h-8 bg-gray-200 my-2"></div>}
                
                <div className="w-20 h-20 rounded-full bg-white border-4 border-gray-100 flex items-center justify-center mb-6 shadow-lg group-hover:border-alpha-green transition-colors duration-300 relative z-10">
                  <SafeIcon icon={step.icon} className="text-3xl text-alpha-navy group-hover:text-alpha-green transition-colors" />
                </div>
                <h4 className="text-xl font-bold text-alpha-navy mb-2">{step.title}</h4>
                <p className="text-sm text-alpha-grayDark">{step.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Journey;